/**
 * Invoice Purpose
 *
 * Classification by the purpose or content of the invoice.
 * Used for filtering and reporting.
 */
export const InvoicePurpose = {
  GOODS: 'GOODS', // Faktura za zboží
  SERVICES: 'SERVICES', // Faktura za služby
  FREIGHT: 'FREIGHT', // Faktura za dopravu
  SUMMARY: 'SUMMARY', // Souhrnná faktura
  PARTIAL: 'PARTIAL', // Dílčí faktura
  FINAL: 'FINAL', // Konečná faktura
  SETTLEMENT: 'SETTLEMENT', // Zúčtovací faktura
  MIXED: 'MIXED' // Smíšená (zboží + služby)
} as const;

export type InvoicePurpose = (typeof InvoicePurpose)[keyof typeof InvoicePurpose];
